import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from '@dhis2/app-runtime';
import { AuthProvider } from './features/auth/AuthContext';
import Layout from './shared/components/Layout';
import Login from './features/auth/Login';
import UserRegistration from './features/organisationUsers/components/UserRegistrationForm';
import OrganisationRegistration from './features/organisationUsers/components/OrganisationRegistration';
import DashboardPage from './features/dashboard/DashboardPage';
import WeeklyProgressTracker from './features/objectivesWeeklyReporting/WeeklyProgressTracker'         
import KPIs from './features/kpisAndKras/KPIPage';                            
import KRAs from './features/kpisAndKras/KRAPage';                            
import TasksPage from './features/tasks/TasksPage';
import MyObjectivesPage from './features/progress/MyObjectivessPage';
import SuperuserOrgManagement from './features/superuserOrganisation/SuperuserOrgManagement';
import PerformanceModule from './features/performance/PerformanceModule';
import LeadershipManagementPage from './features/leadership/LeadershipManagementPage';
import StaffPage from './features/staff/StaffPage';
import {
  ProtectedRoute,
  RegistrationGuard,
  SuperuserOnlyRoute,
  SettingsAccessRoute
} from './shared/components/AccessControl';
import ErrorBoundary from './shared/components/ErrorBoundary';
import OrganisationUpdate from './features/organisationUsers/components/OrganisationUpdate';
import GoalsManagementPage from './features/GoalsManagement/GoalsManagementPage';
import { SessionProvider} from "./features/auth/SessionContext";
import MyProfileEdit from './features/myProfile/MyProfileEdit';
import PerformanceAppraisalPage from './features/appraisal/PerformanceAppraisalPage';
import SetPasswordPage from './features/auth/SetPasswordPage';
import { useEffect } from 'react';



const App = () => {
 return (
    <ErrorBoundary>
      <DataProvider
        config={{
          baseUrl: process.env.REACT_APP_DHIS2_BASE_URL || '',
          apiVersion: parseInt(process.env.REACT_APP_DHIS2_API_VERSION) || 39,
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        }}
      >
        <BrowserRouter>
          <SessionProvider>
            <AuthProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<UserRegistration />} />

              {/* Protected section */}
              <Route element={<ProtectedRoute />}>
                <Route element={<Layout />}>
                  {/* Organisation registration */}
                  <Route path="/organisation" element={<OrganisationRegistration />} />

                  {/* Main dashboard and features */}
                  <Route element={<RegistrationGuard />}>
                    {/* Existing Dashboard routes */}
                    <Route index element={<DashboardPage />} />
                    <Route path="dashboard" element={<DashboardPage />} />
                    <Route path="performance-appraisal/:type" element={<PerformanceAppraisalPage />} />
                    {/* New pages */}
                    <Route path="objectives" element={<WeeklyProgressTracker/>} />
                    <Route path="kpis" element={<KPIs />} />
                    <Route path="kras" element={<KRAs />} />
                    <Route path="tasks" element={<TasksPage />} />
                    <Route path="my-objectives" element={<MyObjectivesPage />} />
                    <Route path="profile" element={<MyProfileEdit />} />
                     <Route path="/set-password" component={SetPasswordPage} />
                    
                    {/* Existing routes */}
                    <Route
                      path="/performance-management/*"
                      element={<PerformanceModule />}
                    />
                    <Route path="leadership-management" element={<LeadershipManagementPage />} />
                    <Route path="staff" element={<StaffPage />} />
                    <Route path="/settings"
                        element={
                          <SettingsAccessRoute>
                            <OrganisationUpdate />
                          </SettingsAccessRoute>
                        }
                      />
                    <Route path="/goals-management" element={<GoalsManagementPage />} />
                  </Route>

                  {/* Superuser-only section */}
                  <Route
                    path="/superuser-org-management"
                    element={
                      <SuperuserOnlyRoute>
                        <SuperuserOrgManagement />
                      </SuperuserOnlyRoute>
                    }
                  />
                </Route>
              </Route>

              {/* Catch-all redirect */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
            </AuthProvider>
          </SessionProvider>
        </BrowserRouter>
      </DataProvider>
    </ErrorBoundary>
  );
};

export default App;
